import { css } from "@emotion/css";

export const wordBreak = css`
    word-break: break-word;
`;
